import axios from "@/utils/request";
export const basePage=(data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/base/page",
        data
    })
}
export const baseDetail=(taskId:string)=>{
    return axios({
        path:"/onlineMedical/medicalComp/base/get/"+ taskId,
    })
}

export const exeBase=(data:any,tempStore:boolean)=>{
    return axios({
        path:"/onlineMedical/medicalComp/base/exeBase/?tempStore=" + tempStore,
        method:"POST",
        data
    })
}
